import { api } from '../api/client';
import { NOTIFICATIONS } from '../api/endpoints';
import { buildQuery } from '../api/helpers';

export const notificationService = {
  list: (params = {}) => {
    const { limit, q, kind } = params;
    const query = buildQuery({
      limit,
      q,
      kind: kind && kind !== 'all' ? kind : undefined,
    });
    return api.get(`${NOTIFICATIONS.LIST}${query}`);
  },
  create: (body) => api.post(NOTIFICATIONS.CREATE, body),
  trackEvent: (id, payload) => api.post(NOTIFICATIONS.EVENTS(id), payload),
  open: (id) => api.post(NOTIFICATIONS.EVENTS(id), { type: 'open' }),
  click: (id) => api.post(NOTIFICATIONS.EVENTS(id), { type: 'click' }),
  share: (id) => api.post(NOTIFICATIONS.EVENTS(id), { type: 'share' }),
  react: (id, reaction) =>
    api.post(NOTIFICATIONS.EVENTS(id), { type: 'react', reaction }),
  markRead: (id) => api.post(NOTIFICATIONS.READ(id)),
  markAllRead: () => api.post(NOTIFICATIONS.READ_ALL),
  invokeAction: (id, actionId) =>
    api.post(NOTIFICATIONS.ACTION(id, actionId)),
  people: (id, params = {}) =>
    api.get(`${NOTIFICATIONS.PEOPLE(id)}${buildQuery(params)}`),
};
